//Redux
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
//Components
import { Modal } from "@allaria-tech/matter/Modal";
//Styles
import styles from "./AccountObjectiveModal.module.scss";
//Utils
import { accountObjectiveModal } from "../../i18n/securities/accountObjectiveModal";

const AccountObjectiveModal = ({ language }: { language: "es" | "en" }) => {
	const { container, item } = styles;

	const dispatch = useAppDispatch();

	const { modalName } = useAppSelector((state) => state.modal);

	const isMobile = window.innerWidth < 768;

	const handleClose = () => {
		dispatch(closeModal());
	};

	return (
		<Modal
			isOpen={modalName === "account-objective"}
			onClose={handleClose}
			title={accountObjectiveModal[language].header}
			// Matter goes full-screen below 768px, where the corner X is easy to
			// miss, so the close action gets a footer button of its own.
			primaryAction={
				isMobile
					? {
						text: accountObjectiveModal[language].close,
						onClick: handleClose,
					}
					: undefined
			}
			footerAlignment="right"
		>
			<section className={container}>
				<div className={item}>
					<p>{accountObjectiveModal[language].incomeTitle}</p>
					<p>{accountObjectiveModal[language].income}</p>
				</div>
				<div className={item}>
					<p>{accountObjectiveModal[language].longTermGrowthTitle}</p>
					<p>{accountObjectiveModal[language].longTermGrowth}</p>
				</div>
				<div className={item}>
					<p>{accountObjectiveModal[language].shortTermGrowthTitle}</p>
					<p>{accountObjectiveModal[language].shortTermGrowth}</p>
				</div>
			</section>
		</Modal>
	);
};

export default AccountObjectiveModal;
